import React, { Component } from 'react';
import { formatDateWithPattern } from '../../../../utils/time/formatDateWithPattern';

class DateTimeFormatter extends Component {
  render() {
    if (!this.props.value) {
      return null;
    }

    return <div>{formatDateWithPattern(this.props.value, 'YYYY/MM/DD h:mm A')}</div>;
  }
}

export default DateTimeFormatter;
